// src/components/pages/ApprovedPage.vue
<script setup>
import { useDataStore } from '@/stores/data'
import { useAppStore } from '@/stores/app'
import BasePage from './BasePage.vue'
import DefaultHeader from '@/components/shared/DefaultHeader.vue'
import ToggleSwitch from '@/components/shared/ToggleSwitch.vue'
import { ref } from 'vue'

const dataStore = useDataStore()
const appStore = useAppStore()
const trackingEnabled = ref(true)
</script>

<template>
	<BasePage name="approved">
		<template #header>
			<DefaultHeader title="Takk for hjelpen!" :hasDatePicker="true" />
		</template>
		<template v-if="dataStore.currentJourney">
			<h2>Din reisedagbok for {{ dataStore.selectedDate.toLocaleDateString('no', { weekday: 'long', day: 'numeric', month: 'long' }) }} er fullført.</h2>
			<p>Dine tilbakemeldinger er viktige for Den nasjonale reisevaneundersøkelsen og gir et bedre grunnlag for å planlegge fremtidens transportløsninger i Norge.</p>
			<p>Du må gjerne gå igjennom og sende inn flere reisedagbøker til oss. Om du åpner appen igjen etter klokken 12:00 en annen dag, vil du få opp reisene dine for dagen i forveien.</p>
			<!-- <div class="form mt-6">
				<div>
					<strong>Vil du fortsette å bidra?</strong>
					<p>Ved å fortsette analysene gir du oss et mer komplett bilde av reisemønster i områder der du ferdes. Du vil få tilgang til å se reisedagbøker for flere dager, og du kan gå igjennom så mange dager du ønsker.</p>
				</div>
				<div class="mt-2 button full green" @click="dataStore.clearJourneyDayApproval()">
					<span>Jeg blir med videre</span>
					<i class="fa-solid fa-play"></i>
				</div>
			</div> -->
		</template>
		<template #footer>
			<div class="button full green" @click="appStore.startInit(true)">
				Oppdater
				<i class="fa-solid fa-rotate-right"></i>
			</div>
			<div class="button full white border" @click="dataStore.clearJourneyDayApproval()" v-if="dataStore.userCanUndo">
				<span>Gjenåpne dagen</span>
				<i class="fa-solid fa-rotate-left"></i>
			</div>
		</template>
	</BasePage>
</template>

<style scoped>
.form {
	padding: 1.5rem;
	background-color: #eee;
	border-radius: 0.5rem;
	display: flex;
	gap: 0.5rem;
	flex-direction: column;
}
</style>
